module.exports = __webpack_public_path__ + "img/box_primary.9430bbb8.png";